import React, { useState }from 'react';
import { compose } from 'ramda';
import connect from 'react-redux/es/connect/connect';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import styleFile from '../style.js';
import Form from '@synergycms_core/components/generic/Form';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import InputField from '@synergycms_core/components/generic/Form/InputField';
import ButtonSubmit from '@synergycms_core/components/generic/Form/ButtonSubmit';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';
import SelectCountry from '@synergycms_core/components/functional/CustomerForm/SelectCountry';
import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';

import ConditionsModal from '../../../../../components/functional/CustomerForm/ConditionsModal';

import actions from '../../../../../store/actions';

const LoyaltyRegister = ({ theme: { styles: { classes }}, countries, defaultCountry, langCode, onView, register }) => {

  const [error, setError] = useState(false);

  const handleSubmit = (validForm, inputList) => {
    
    setError(false);

    if(!validForm) {
        return Promise.reject();
    }

    return register(inputList)
      .then(() => {
        onView('login');
      }).catch((e)=>{
        setError(e.message);
      });
  };

  return (
    <div className={classes.register}>
      <Form id="RegisterForm" onSubmit={handleSubmit} >
        <div>
          <label className={classes.boxText} useref={'name'}>
            <InputField model={'name'} innerStyle={['inputText', classes.inputText]} validationsFields={{ field: 'nombre' }}
              validations={[ 'required', { type: 'minLength', minLength: 2 }, { type: 'maxLength', maxLength: 100 } ]}/>
            <InputNotify model={'name'} />
            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%nombre fidelizacion%_'} translate={true} />
          </label>
          <label className={classes.boxText} useref={'surname'}>
            <InputField model={'surname'} innerStyle={['inputText', classes.inputText]} validationsFields={{ field: 'apellidos' }}
              validations={[ 'required', { type: 'minLength', minLength: 2 }, { type: 'maxLength', maxLength: 100 } ]}/>
            <InputNotify model={'surname'} />
            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%apellidos fidelizacion%_'} translate={true} />
          </label>
          <label className={classes.boxText} useref={'email'}>
            <InputField model={'email'} type={'email'} innerStyle={['inputText', classes.inputText]} validationsFields={{ field: 'email' }}
              validations={[ 'required', 'email']}/>
            <InputNotify model={'email'} />
            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%email fidelizacion%_'} translate={true} />
          </label>
          <div>
            <div className={[classes.boxText,classes.boxTextTel].join(' ')}>
              <SelectCountry defaultCountry={defaultCountry} countries={countries} arrowPosition={langCode} />
            </div>
            <label useref={'phone'} className={classes.boxText}>
              <InputField model={'phone'} type={'tel'} innerStyle={['inputText', classes.inputText]} validationsFields={{ field: 'teléfono' }}
                validations={['required', 'phone']}/>
              <InputNotify model={'phone'} />
              <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%telefono fidelizacion%_'} translate={true} />
            </label>
          </div>
          <label className={classes.boxText} useref={'password'}>
            <InputField model={'password'} type={'password'} innerStyle={['inputText', 'roboto16BlackModified', classes.inputText]} validationsFields={{ field: 'password' }}
              validations={['required', { type: 'maxLength', maxLength: 16 }, { type: 'minLength', minLength: 8 }, { type: 'compareField', invalidText: '', alterModel: 'repeatPassword', alterField: 'repetir password' } ]}/>
            <InputNotify model={'password'} />
            <RichText innerStyle={[classes.labelText, 'capitalize']} text={'_%contrasena fidelizacion%_'} translate={true} />
          </label>
          <label className={classes.boxText} useref={'repeatPassword'}>
            <InputField model={'repeatPassword'} type={'password'} innerStyle={['inputText', 'roboto16BlackModified', classes.inputText]} validationsFields={{ field: 'repetir password' }}
              validations={[ 'required', { type: 'maxLength', maxLength: 16 }, { type: 'minLength', minLength: 8 } , { type: 'compareField', alterModel: 'password', alterField: 'password' } ]}/>
            <InputNotify model={'repeatPassword'} />
            <RichText innerStyle={[classes.labelText]} ucFirst={true} text={'_%repetir contrasena fidelizacion%_'} translate={true} />
          </label>
        </div>
        { error && <RichText innerStyle={[classes.errorText]} text={error} translate={true} /> }
        <div className={[classes.textLeft, 'text', classes.loyaltyConditions].join(' ')}>
          <label className={classes.checkBox}>
            <CheckboxField
              defaultValue={false}
              type={'checkbox'}
              validations={['required']}
              validationsFields={{ field: '' }}
              model={'accept_conditions'}
              innerStyle={['inputCheck', classes.inputCheck]}
              css={{ invalid: null, valid: null }}/>

            <React.Fragment>
              <RichText translate={true} ucFirst={true} innerStyle={['roboto14Gray300']} text={'_%leido fidelizacion%_'}/>{' '}
              <ConditionsModal modalTitle={'_%política de privacidad%_'} modalText={'_%condiciones contratacion text%_'}/>{' '}
              <RichText translate={true} text={'_%y%_'} innerStyle={['roboto14Gray300']} />{' '}
              <RichText translate={true} text={'_%las%_'} innerStyle={['roboto14Gray300']} />{' '}
              <ConditionsModal modalTitle={'_%términos y Condiciones del programa%_'} modalText={'_%loyalty_terms%_'}/>
              <InputNotify model={'accept_conditions'} css={{ valid: null }}/>
            </React.Fragment>           
          </label>
        </div>
        <div className={[classes.textLeft, 'text', classes.loyaltySubscribe].join(' ')}>
          <label className={classes.checkBox}>
            <CheckboxField
              defaultValue={false}
              type={'checkbox'}
              model={'subscribed'}
              innerStyle={['inputCheck', classes.inputCheck]}
            />
            <RichText
              translate={true}
              ucFirst={true}
              innerStyle={['roboto14Gray300']} 
              text={'_%suscrito fidelizacion%_'}
            />
          </label>
        </div>
        <ButtonSubmit richText={{ text: '_%register fidelizacion%_', translate: true, ucFirst: true }} innerStyle={[classes.uppercase, classes.fullWidth, 'toggleSecondButton']} />
      </Form>
      <div className={classes.textCenter}>
        <RichText innerStyle={['roboto14Gray300']} text={'_%cuenta fidelizacion%_'} translate={true}/>{' '}  
        <Button onClick={ () => onView('login') } text={'_%login fidelizacion%_'} richText={{translate:true}} innerStyle={[classes.uppercase, 'roboto14Gray300']} />
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    register: (inputList) => {
      return dispatch(actions.customer.loyalty.register(inputList));
    }
  };
};

const mapStateToProps = (state) => {

  const langCode = state.getIn(['customer', 'lang_info', 'code']).toUpperCase()
  const countries = state.get('countries');
  const defaultCountryCode = state.getIn(['customer', 'country', 'code'], 'ES');

  const defaultCountry =  //countries.find(country => country.get('alpha2') === reservation.getIn(['customer', 'country'], false)) ||
                          countries.find(country => country.get('alpha2') === defaultCountryCode) ||
                          countries.find(country => country.get('alpha2') === 'ES');
  return {
    langCode: langCode,
    countries: countries,
    defaultCountry: defaultCountry,
  }

};


export default compose(
  connect(mapStateToProps, mapDispatchToProps), 
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
  )(LoyaltyRegister);
